import React from "react";
import { HOME_LINK } from "@/constants/URLs";
import {
  Wrapper,
  Container,
  LogoWrapper,
  LogoLink,
  Logo,
  TopBox,
  Title,
  FeatureBox,
  FeatureItem,
  ImageBox,
  ImageHolder,
  ImageDiv,
  FeatureTitle,
  Counter,
} from "./heroStyle";

function HeroSection({ data = {}, width }) {
  const { title, features } = data;
  return (
    <Wrapper>
      <Container>
        <TopBox>
          <LogoWrapper>
            <LogoLink to={HOME_LINK} href={HOME_LINK} variant="link1">
              <Logo
                icon={"icon-brand-logo-light"}
                height={width <= 767 ? "34px" : "42px"}
                width={width <= 767 ? "80px" : "92px"}
              />
            </LogoLink>
          </LogoWrapper>
          <Title variant="display2" isExtraBold>
            {title}
          </Title>
          {features?.length > 0 && width > 1079 && (
            <FeatureBox>
              {features?.map((item, index) => (
                <FeatureItem key={index}>
                  <ImageBox>
                    <Counter isExtraBold variant="label4" letterSpacing="0.4px">
                      {index + 1}
                    </Counter>
                    <ImageDiv>
                      {item.image && <ImageHolder src={item.image} />}
                    </ImageDiv>
                  </ImageBox>
                  <FeatureTitle variant="label3">{item.title}</FeatureTitle>
                </FeatureItem>
              ))}
            </FeatureBox>
          )}
        </TopBox>
      </Container>
    </Wrapper>
  );
}

export default HeroSection;
